import React, { useState, useEffect } from "react";
import ReactGA from "react-ga";
import axios from "axios";
import styled from "styled-components";
// import groupBy from 'lodash.groupby'
import ItemSearch from "./search-box";
import Loader from "./loader";

const SearchResultsContainer = styled.div`
  background: #f0f0f0;
  padding: 15px;
  h3 {
    margin-bottom: 5px;
  }
`;

const GroupContainer = styled.div`
  border: 1px solid #ddd;
  background-color: #fff;
  padding: 15px;

  h3 {
    font-weight: normal;
    margin-top: 0;
    line-height: 1;
    margin-bottom: 15px;
  }
`;

const YearContainer = styled.div`
  /* border-bottom: solid 1px #ddd; */
  margin-bottom: 20px;
`;

const SearchItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;

  &:not(:last-child) {
    border-bottom: dashed 1px #ccc;
    margin-bottom: 10px;
    padding-bottom: 3px;
  }
`;

const SearchBreadcrumb = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  line-height: 1;
  color: #777;
  margin-bottom: 2px;
`;

const SearchLink = styled.div`
  text-transform: uppercase;
`;

const Search = ({
  match: {
    params: { searchText = "logan" },
  },
}) => {
  const [data, setData] = useState([]);
  const [grouped, setGrouped] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(
    () => ReactGA.pageview(window.location.pathname + window.location.search),
    [],
  );

  useEffect(() => {
    const search = async () => {
      setLoading(true);
      const results = await axios.get(`/search/${searchText}`);
      setData(results.data);
      setLoading(false);
    };
    search();
  }, [searchText]);

  const groupBy = (items, key) =>
    items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {},
    );

  const buildLocation = (item) => {
    let locationText = "";
    locationText += item.GreatGrandparentName
      ? `${item.GreatGrandparentName} / `
      : "";
    locationText += item.GrandparentName ? `${item.GrandparentName} / ` : "";
    locationText += item.ParentName ? item.ParentName : "";

    return locationText;
  };

  const buildLink = (item) => {
    let url = "";

    if (item.Bucket == "Expenditures") {
      url += "/department";
    } else if (item.Bucket == "Vendor") {
      url += "/vendor";
    } else {
      url += "/revenue";
    }

    url += `/${item.Year}`; // Year

    // Expenditure URL creation
    if (item.Bucket == "Expenditures") {
      if (item.GreatGrandparentName) {
        url += `/${item.Grandparent.trim()}/${item.Parent.trim()}/${item.Child.toString().trim()}`;
        url += `?deptName=${item.GreatGrandparentName.trim()}`; // Dept
        url += `&charDesc=${item.GrandparentName.trim()}`; // Cateogry
        url += `&objDesc=${item.ParentName.trim()}`; // SubCategory
        url += `&lineItem=${item.Name.trim()}${item.Amount}`;
      } else if (item.GrandparentName) {
        url += `/${item.Grandparent.trim()}/${item.Parent.trim()}/${item.Child.toString().trim()}`;
        url += `?deptName=${item.GrandparentName.trim()}`; // Dept
        url += `&charDesc=${item.ParentName.trim()}`; // Cateogry
        url += `&objDesc=${item.Name.trim()}`; // SubCategory
      } else if (item.ParentName) {
        url += `/${item.Parent.trim()}/${item.Child.toString().trim()}`;
        url += `?deptName=${item.ParentName.trim()}`; // Dept
        url += `&charDesc=${item.Name.trim()}`; // Cateogry
      } else {
        url += `/${item.Child.toString().trim()}`;
        url += `?deptName=${item.Name.trim()}`; // Dept
      }
    }

    // Revenue URL creation
    if (item.Bucket == "Revenue") {
      if (item.GrandparentName) {
        url += `/${item.Parent.trim()}/${item.Child.toString().trim()}`;
        url += `?lineDesc=${item.GrandparentName.trim()}`; // Dept
        url += `&objDesc=${item.ParentName.trim()}`; // Cateogry
        url += `&lineItem=${item.Name.trim()}${item.Amount}`;
      } else if (item.ParentName) {
        url += `/${item.Parent.trim()}/${item.Child.toString().trim()}`;
        url += `?lineDesc=${item.ParentName.trim()}`; // Dept
        url += `&objDesc=${item.Name.trim()}`; // Cateogry
      } else {
        url += `/${item.Child.toString().trim()}`;
        url += `?lineDesc=${item.Name.trim()}`; // Dept
      }
    }

    // Vendor URL creation
    if (item.Bucket == "Vendor") {
      url += `/${item.Child.toString().trim()}?vendorName=${
        item.ParentName
      }&lineItem=${item.Name.trim()}${item.Amount}`;
    }

    return `<a href="${url}">${item.Name}</a>`;
  };

  useEffect(() => {
    const _grouped = groupBy(data, "Bucket");
    Object.keys(_grouped).forEach((key) => {
      _grouped[key] = groupBy(_grouped[key], "Year");
    });
    setGrouped(_grouped);
  }, [data]);

  return (
    <div>
      <h2 style={{ textAlign: "center", marginBottom: 10 }}>Search</h2>
      <div
        style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}
      >
        <ItemSearch searchText={searchText} />
      </div>
      {!loading ? (
        <SearchResultsContainer>
          <div>
            {data.length ? (
              <span>
                Showing{" "}
                {data.length === 50 ? (
                  <span>Top 50</span>
                ) : (
                  <span>{data.length}</span>
                )}{" "}
                Results
              </span>
            ) : (
              <span>No Results</span>
            )}
          </div>
          <div style={{ marginTop: 20 }}>
            {Object.keys(grouped).map((key) => (
              <div key={key}>
                <h3>{key}</h3>
                <GroupContainer>
                  {Object.keys(grouped[key])
                    .sort((a, b) => b - a)
                    .map((year) => (
                      <YearContainer key={year}>
                        <h3>{year}</h3>
                        {grouped[key][year].map((item, i) => (
                          <SearchItem key={`${year}-${i}`}>
                            <div>
                              <SearchBreadcrumb>
                                {buildLocation(item)}
                              </SearchBreadcrumb>
                              <SearchLink
                                dangerouslySetInnerHTML={{
                                  __html: buildLink(item),
                                }}
                              ></SearchLink>
                            </div>
                            <div>${item.Amount.toFixed(2)}</div>
                          </SearchItem>
                        ))}
                      </YearContainer>
                    ))}
                </GroupContainer>
              </div>
            ))}
          </div>
        </SearchResultsContainer>
      ) : (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
        >
          <Loader />
        </div>
      )}
    </div>
  );
};

export default Search;
